<template>
    <div class="m-timeline-1__item-body" v-if="!check_end" id="rating-form">
        <fieldset>
            <p class="rating-text">
                <button class="btn btn-sm pull-left" id="previous" v-show="current_step > 0 && current_step < max_step"
                    @click="previouStep()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="30">
                        <path
                            d="M52.01 34.02H16.839l11.587 11.574a2.002 2.002 0 1 1-2.833 2.829L10.571 33.418a1.998 1.998 0 0 1 0-2.829l15.022-15.004a2.002 2.002 0 1 1 2.833 2.829L16.805 30.021H52.01a2 2 0 1 1 0 4z"
                            fill-rule="evenodd"></path>
                    </svg></button>
                <button class="btn btn-sm pull-right" id="next" v-show="current_step < (max_step - 1)"
                    @click="nextStep()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="30">
                        <path
                            d="M38.428 48.457a2.002 2.002 0 0 1-2.833-2.83l11.621-11.606H12.01a2 2 0 0 1 0-4h35.172L35.595 18.448a2.002 2.002 0 1 1 2.833-2.83L53.45 30.624a1.998 1.998 0 0 1 0 2.83z"
                            fill-rule="evenodd"></path>
                    </svg></button>
            </p>
        </fieldset>
        <fieldset class="step" id="step_rating" v-show="current_step == 0">
            <p class="rating-text">
                <label><!-- Nhìn chung, bạn hài lòng đến mức nào khi chúng tôi giải quyết yêu cầu của bạn ngày hôm
                    nay?  -->{{rating_text_data.star_text}} </label>
            <div class="rating">
                <ul class="list">
                    <li @click="rate(star)" v-for="star in max_stars" :class="{ 'active' : star <= current_star }"
                        :key="star.stars" class="star">
                        <i :class="star <= current_star ? 'fas fa-star' : 'far fa-star' "></i>
                    </li>
                </ul>
                <div v-if="hasCounter" class="info counter"><span class="score-rating">{{ stars }}</span><span
                        class="divider">/</span><span class="score-max">{{ maxStars }}</span></div>
            </div>
            </p>
        </fieldset>
        <!-- <fieldset class="step" id="step_confirm" v-show="current_step == 1">
            <p class="rating-text">
                <label>Không biết là chúng tôi đã có thể giúp bạn giải đáp các thắc mắc hôm nay
                    chưa?</label>
                    <div class="text-center">
                        <button class="btn btn-primary" @click="answerStepConfirm(' yes')">Có</button>
                        <button class="btn btn-secondary" @click="answerStepConfirm('no')">Không</button>
                    </div>
                
            </p>
        </fieldset> -->
        <fieldset class="step" id="step_confirm" v-show="current_step == 1">
            <p class="rating-text">
                <label><!-- Bất kỳ phản hồi nào khác để chia sẻ với chúng tôi? --> {{parseInt(current_star) > 0 ?
                    rating_text_data.rates[parseInt(current_star)-1] : ""}}</label>
                <textarea rows="2" class="recommend form-control" v-model="recomend_content"
                    :placeholder="$t('share_more_reviews')"
                    aria-label="Bất kỳ phản hồi nào khác để chia sẻ với chúng tôi?, "></textarea>
                <button class="btn btn-primary" @click="sendRecommend()">{{$t('send')}}</button>
            </p>
        </fieldset>
        <fieldset class="step" id="step_result" v-show="current_step == 2">
            <p class="rating-text">
                <label>{{rating_text_data.result_text}}</label>
                <label>{{$t('result')}}:</label>
            <div class="rating">
                <ul class="list">
                    <li v-for="star in max_stars" :class="{ 'active' : star <= current_star }" :key="star.stars"
                        class="star">
                        <i :class="star <= current_star ? 'fas fa-star' : 'far fa-star' "></i>
                    </li>
                </ul>
                <div v-if="hasCounter" class="info counter"><span class="score-rating">{{ stars }}</span><span
                        class="divider">/</span><span class="score-max">{{ maxStars }}</span></div>
            </div>
            <label>{{$t('feedback')}}: {{recomend_content}}</label>
            </p>
        </fieldset>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                current_star: 0, //tăng lên 1 để không lỗi -1 {{rating_text_data.rates[parseInt(current_star)-1]}}
                max_stars: 5,
                current_step: 0,
                confirm_step: '',
                max_step: 0,
                check_step: {},
                recomend_content: '',
                check_end: false,
                hasCounter: false,
                rating_text_data_default: {
                    'star_text': ''
                },
                rating_text_data: [],
                /*rating_text_data_vietjet:{
                    'star_text' : 'Amy cảm ơn bạn nhiều! Bạn vui lòng đánh giá mức độ hài lòng của bạn đối với Amy theo thang điểm từ 1 đến 5 sao (5 sao là mức độ hài lòng cao nhất).',
                    'rates': [
                        'Chia sẻ thêm giúp Amy về các điểm chưa tốt của Amy vào bên dưới để Amy cải thiện thêm 😍😍😍',
                        'Amy muốn tìm hiểu thêm về trải nghiệm của bạn',
                        'Amy rất lấy làm tiếc khi hỗ trợ chưa được tốt cho bạn! 😥',
                        'Amy rất vui khi biết rằng bạn đã hài lòng với Amy và các sản phẩm và dịch vụ của Vietjet.',
                        'Amy rất vui khi biết rằng bạn đã hài lòng với Amy và các sản phẩm và dịch vụ của Vietjet.'
                    ]
                },*/
                rating_text_data_vi: {
                    'star_text': 'Amy cảm ơn bạn nhiều! Bạn vui lòng đánh giá mức độ hài lòng của bạn đối với Amy theo thang điểm từ 1 đến 5 sao (5 sao là mức độ hài lòng cao nhất).',
                    'result_text': "Một lần nữa xin cảm ơn bạn đã sử dụng dịch vụ của Vietjet. Amy hy vọng bạn có một ngày tuyệt vời😍😍😍",
                    'rates': [
                        'Chia sẻ thêm giúp Amy về các điểm chưa tốt của Amy vào bên dưới để Amy cải thiện thêm 😍😍😍',
                        'Amy muốn tìm hiểu thêm về trải nghiệm của bạn',
                        'Amy rất lấy làm tiếc khi hỗ trợ chưa được tốt cho bạn! 😥',
                        'Amy rất vui khi biết rằng bạn đã hài lòng với Amy và các sản phẩm và dịch vụ của Vietjet.',
                        'Amy rất vui khi biết rằng bạn đã hài lòng với Amy và các sản phẩm và dịch vụ của Vietjet.'
                    ]
                },
                rating_text_data_en: {
                    'star_text': 'Amy thank you so much! Please rate your satisfaction with Amy on a scale of 1 to 5 stars (5 stars is the highest level of satisfaction).',
                    'result_text': "Once again, thank you for using Vietjet's services. Amy hope you have a great day😍😍😍",
                    'rates': [
                        "Share more to help Amy about Amy's bad points below so that Amy can improve more 😍😍😍",
                        'Amy wants to learn more about your experience',
                        'Amy is very sorry that the support is not good for you!',
                        'Amy is happy to know that you are satisfied with me and the products and services.',
                        'Amy is happy to know that you are satisfied with me and the products and services.'
                    ]
                }


            }
        },
        created: function () {
            // console.log($('fieldset.step'));
        },
        mounted: function () {
            this.max_step = $('fieldset.step').length;
            if (this.lang == 'vi') {
                this.rating_text_data = this.rating_text_data_vi;
            } else if (this.lang == 'en') {
                this.rating_text_data = this.rating_text_data_en;
            } else {
                this.rating_text_data = this.rating_text_data_vi;
            }
        },
        methods: {
            rate(star) {
                if (typeof star === 'number' && star <= this.max_stars && star >= 0) {
                    this.current_star = this.current_star === star ? star - 1 : star
                    this.check_step[this.current_step] = true;
                    this.current_step += 1;
                    this.rating_submit('rating_star', this.current_star);
                }
            },
            previouStep: function () {
                this.current_step -= 1;
            },
            nextStep: function () {
                if (this.validateNextStep(this.current_step)) this.current_step += 1;
            },
            validateNextStep: function (current_step) {
                return current_step < (this.max_step - 1) && this.check_step[current_step];
            },
            sendRecommend: function () {

                this.check_step[this.current_step] = true;
                this.current_step += 1;
                if (this.recomend_content) {
                    this.rating_submit('rating_recommend', this.recomend_content);
                }
            },
            answerStepConfirm: function (value) {
                this.confirm_step = value;
                this.check_step[this.current_step] = true;
                this.current_step += 1;
                this.rating_submit('rating_answered', value);
            },
            rating_submit: function (type, value) {
                var $self = this;
                axios.post('/app/v1/public/RATING', {
                    page_id: livechat.getId(),
                    type: type,
                    value: value,
                    sender_id: $self.st_token,
                    name: window.user.name,
                    windowInfo: livechat.windowInfo,
                    survey_data: {
                        name: window.user.name,
                        phone: window.user.phone,
                        email: window.user.email,
                        address: window.user.address
                    },
                    properties: window.user.properties
                }).then((response) => {
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        watch: {
            current_step: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue >= oldValue) {
                        if (newValue < this.max_step) {
                            var current_fs = $($('fieldset.step')[this.current_step - 1]);
                            var next_fs = $($('fieldset.step')[this.current_step]);
                            if (next_fs.length)
                                next_fs.show();
                            current_fs.animate({
                                opacity: 0
                            }, {
                                step: function (now, mx) {
                                    var scale = 1 - (1 - now) * 0.2;
                                    var left = (now * 50) + "%";
                                    var opacity = 1 - now;
                                    current_fs.css({
                                        'transform': 'scale(' + scale + ')',
                                        // 'position': 'absolute'
                                    });
                                    next_fs.css({
                                        'left': left,
                                        'opacity': opacity
                                    });
                                },
                                duration: 800,
                                complete: function () {
                                    current_fs.hide();
                                    var animating = false;
                                },

                            });
                        }
                    }
                    else {
                        var current_fs = $($('fieldset.step')[this.current_step + 1]);
                        var previous_fs = $($('fieldset.step')[this.current_step]);
                        previous_fs.show();
                        current_fs.animate({
                            opacity: 0
                        }, {
                            step: function (now, mx) {
                                var scale = 0.8 + (1 - now) * 0.2;
                                var left = ((1 - now) * 50) + "%";
                                var opacity = 1 - now;
                                current_fs.css({
                                    'left': left
                                });
                                previous_fs.css({
                                    'transform': 'scale(' + scale + ')',
                                    'opacity': opacity
                                });
                            },
                            duration: 800,
                            complete: function () {
                                current_fs.hide();
                                var animating = false;
                            },
                        });
                    }
                    if (newValue == this.max_step && this.max_step) {
                        this.check_end = true;
                        // alert('Đã điền đầy đủ form');
                    }
                }
            },
        },
        computed: {
            st_token() {
                return this.$store.state.st_token;
            },
            lang() {
                return this.$store.state.lang;
            },
            page() {
                return this.$store.state.page;
            }
        },
    }
</script>
<style scoped lang="css">
    #rating-form {
        width: 90%;
        border: 1px solid #E8E8EB;
        padding: 0 18px 5px;
        margin: 0px 17px;
    }

    .m-timeline-1__item-body {
        margin-bottom: 1rem
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .rating {
        display: flex;
        flex-direction: column;
        align-items: center;
        /* padding: 50px; */
        color: #b7b7b7;
        /* background: #fff; */
        border-radius: 8px;
        /* box-shadow: 0 6px 33px rgba(19, 18, 18, 0.09); */
    }

    .rating .list {
        padding: 0;
        margin: 0 20px 0 0;
    }

    .rating .list .star {
        display: inline-block;
        font-size: 42px;
        transition: all .2s ease-in-out;
        cursor: pointer;
    }

    .rating .list .star.active {
        color: #ffe100;
    }

    .rating .list .star:first-child {
        margin-left: 0;
    }

    .rating .list:hover .star {
        color: #ffe100;
    }

    .rating .list .star:hover~.star:not(.active) {
        color: inherit;
    }

    .info {
        margin-top: 15px;
        font-size: 40px;
        text-align: center;
        display: table;
    }

    .info .divider {
        margin: 0 5px;
        font-size: 30px;
    }

    .info .score-max {
        font-size: 30px;
        vertical-align: sub;
    }

    fieldset .rating-text {
        word-break: inherit;
        margin-bottom: 20px;
        margin: 0 0 10px;
        line-height: 1.6;
    }

    fieldset .rating-text button#previous,
    fieldset .rating-text button#next {
        background: inherit;
    }

    fieldset .rating-text label {
        display: flex;
    }

    fieldset .rating-text textarea {
        margin-bottom: 5px;
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
    }

    .btn-sm,
    .btn-group-sm>.btn {
        padding: 5px 10px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }

    .pull-right {
        float: right;
    }

    .pull-left {
        float: left;
    }

    .btn-primary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .form-control {
        display: block;
        width: 100%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }

    .text-center {
        text-align: center;
    }
</style>